import React, { useEffect } from "react";
import DriverLicenceListing from "./pages/DriverLicenceListing";

function DriverLicence(props) {
    const { setActive } = props;
    useEffect(() => {
      //setActive(3);
    }, []);

    return <DriverLicenceListing />
};

export default DriverLicence;